import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { AllUserApprovedEntryListType } from "../../../redux/listing/listingTypes";

import { CircularAvatar } from "../../commons";
type AppProps = {
  data: AllUserApprovedEntryListType[] | [];
  tableHeader: TableHeadersType[];
};
const AllUserApprovedEntryTableData = ({ data, tableHeader }: AppProps) => {
  return (
    <>
      {data &&
        data?.length > 0 &&
        data?.map((itemData: any) => {
          return (
            <tr key={itemData?._id}>
              {tableHeader?.map((item: TableHeadersType) => {
                if (item?.value == "name") {
                  return (
                    <td>
                      <div
                        className="ml-2"
                        style={{
                          display: "flex",
                          justifyContent: "left",
                          alignItems: "center",
                          gap: "7px",
                        }}
                      >
                        <CircularAvatar
                          name={`${itemData?.user_detail?.first_name} ${itemData?.user_detail?.last_name}`}
                          image={
                            itemData?.user_detail?.profile_pic &&
                            itemData?.user_detail?.profile_pic?.file_url
                          }
                        />
                        <div>
                          {`${itemData?.user_detail?.first_name} ${itemData?.user_detail?.last_name} `}
                        </div>
                      </div>
                    </td>
                  );
                } else if (item?.value == "expense") {
                  return (
                    <td>
                      {itemData?.expense_count
                        ? itemData?.expense_count
                        : "--/--"}
                    </td>
                  );
                } else if (item?.value == "sales") {
                  return (
                    <td>
                      {itemData?.sales_count ? itemData?.sales_count : "--/--"}
                    </td>
                  );
                } else if (item?.value == "other") {
                  return (
                    <td>
                      {itemData?.others_count
                        ? itemData?.others_count
                        : "--/--"}
                    </td>
                  );
                }
                else if (item?.value == "manufacturing_journal_count") {
                  return (
                    <td>
                      {itemData?.manufacturing_journal_count
                        ? itemData?.manufacturing_journal_count
                        : "--/--"}
                    </td>
                  );
                }
                else if (item?.value == "total_count") {
                  return (
                    <td>
                      {itemData?.total_count
                        ? itemData?.total_count
                        : "--/--"}
                    </td>
                  );
                }
              })}
            </tr>
          );
        })}
    </>
  );
};

export default AllUserApprovedEntryTableData;
